module.exports = __webpack_public_path__ + "img/fish5.5c76483c.png";